module.exports = __webpack_public_path__ + "img/shield-check.be007103.svg";